module.exports = __webpack_public_path__ + "img/bd-logo.7ad162b2.png";